import React from 'react';

import UserAdminAddEditUserInfo from './UserAdminAddEditUserInfo';

const UserAdminAddUser = () => {
  return <UserAdminAddEditUserInfo title="User Information" />;
};

export default UserAdminAddUser;
